<template>
  <div class="container">
    <van-cell
      class="header"
      :title="title"
      title-class="title"
    />
    <LongList
      :api-method="getData"
    >
      <template #default="{list}">
        <CommonTable
          v-if="list && list.length"
          class="table"
        >
          <tr>
            <th>
              时间
            </th>
            <th>
              类型
            </th>
            <th>
              商家参与分成(元)
              <van-icon
                name="question-o"
                @click="showTip=true"
              />
            </th>
            <th>
              商家分成(元)
            </th>
          </tr>
          <tr
            v-for="(item,index) in list"
            :key="index"
          >
            <td>
              {{ item.time }}
            </td>
            <td>
              {{ getTypeName(item.type) }}
            </td>
            <td>
              {{ item.totalAmount }}
            </td>
            <td>
              {{ item.dividedAmount }}
            </td>
          </tr>
        </CommonTable>
      </template>
    </LongList>
    <TipModal
      v-model="showTip"
      :title="tip.title"
      :msg="tip.msg"
    />
  </div>
</template>
<script>
import {
  mapMutations,
} from 'vuex';
import CommonTable from '@/components/CommonTable';
import { getMonthDay } from '@/util/filter';
import LongList from '@/components/LongList';
import TipModal from '@/components/TipModal';
import Api from '@/api/bill';

export default {
  name: 'AgentActivityDailyBillDetail',
  components: {
    LongList, TipModal, CommonTable,
  },
  data() {
    const {
      billDay, id, poiId, cutDay, amount,
    } = this.$route.query;
    return {
      billDay,
      id,
      poiId,
      cutDay,
      amount,
      tip: { title: '商家参与分成', msg: '【商家参与分成】为扣除经营成本后商家参与分成的金额。' },
      showTip: false,
    };
  },
  computed: {
    title() {
      const date = getMonthDay(this.cutDay);
      return `${date}共${this.amount}元`;
    },
  },
  methods: {
    ...mapMutations('billModule', ['setCurrentAgentActivityBillInfo']),
    getData(pageNum, pageSize) {
      const {
        billDay, id: agreementId, poiId, cutDay,
      } = this;
      const params = {
        billDay,
        agreementId,
        poiId,
        cutDay,
        pageNum,
        pageSize,
      };

      return Api.getAgentActivityDailyBill(params);
    },
    getTypeName(type) {
      switch (type) {
      case 0:
        return '退款';
      case 1:
        return '收入';
      case 2:
        return '售转租';
      default:
        return '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  padding: 18px 16px;
  background: none;
  .title {
    text-align: left;
    font-weight: bold;
    font-size: 36px;
    color: black;
  }
  .value {
    font-size: 30px;
    color: black;
  }
}

.table {
  width: 100%;
  td {
    width: 25%;
  }
}

</style>
